// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let WizardFormUtils = require("../../client/wizard/WizardFormUtils.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DevelopmentSampleUnitSummary = require("../../common/Development/DevelopmentSampleUnitSummary.bs.js");
let ConversationsListItemContext_conversation_graphql = require("../../../__generated__/ConversationsListItemContext_conversation_graphql.bs.js");
let ConversationsListItemContextLocationDisplay_location_graphql = require("../../../__generated__/ConversationsListItemContextLocationDisplay_location_graphql.bs.js");

function ConversationsListItemContext$Details(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: props.top,
        className: "line-clamp-1"
      }),
      JsxRuntime.jsx("div", {
        children: props.bottom,
        className: "text-sm text-gray-600 line-clamp-1"
      })
    ],
    className: "flex flex-col"
  });
}

let Details = {
  make: ConversationsListItemContext$Details
};

let convertFragment = ConversationsListItemContextLocationDisplay_location_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsListItemContextLocationDisplay_location_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsListItemContextLocationDisplay_location_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationsListItemContextLocationDisplay_location_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationsListItemContextLocationDisplay_location_graphql.node, convertFragment, fRef);
}

let LocationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationsListItemContext$LocationDisplay(props) {
  let isRental = props.isRental;
  let location = RescriptRelay_Fragment.useFragment(ConversationsListItemContextLocationDisplay_location_graphql.node, convertFragment, props.location);
  let tmp;
  switch (location.__typename) {
    case "PropertyLocationWithHiddenAddress" :
      let locationDisplay = location.locationDisplay;
      tmp = locationDisplay !== undefined ? JsxRuntime.jsx(ConversationsListItemContext$Details, {
          top: locationDisplay,
          bottom: "Hidden Address" + (
            isRental ? " (Rental)" : ""
          )
        }) : null;
      break;
    case "PropertyLocationWithVisibleAddress" :
      let address = location.address;
      if (address !== undefined) {
        let locationDisplay$1 = location.locationDisplay;
        tmp = locationDisplay$1 !== undefined ? JsxRuntime.jsx(ConversationsListItemContext$Details, {
            top: locationDisplay$1,
            bottom: address + (
              isRental ? " (Rental)" : ""
            )
          }) : null;
      } else {
        tmp = null;
      }
      break;
    case "__unselected" :
      tmp = null;
      break;
  }
  return JsxRuntime.jsx("div", {
    children: tmp
  });
}

let LocationDisplay = {
  LocationFragment: LocationFragment,
  make: ConversationsListItemContext$LocationDisplay
};

let convertFragment$1 = ConversationsListItemContext_conversation_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsListItemContext_conversation_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsListItemContext_conversation_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationsListItemContext_conversation_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationsListItemContext_conversation_graphql.node, convertFragment$1, fRef);
}

let ConversationFragment_conversationContextTypeV5_decode = ConversationsListItemContext_conversation_graphql.Utils.conversationContextTypeV5_decode;

let ConversationFragment_conversationContextTypeV5_fromString = ConversationsListItemContext_conversation_graphql.Utils.conversationContextTypeV5_fromString;

let ConversationFragment_developmentProjectUnitType_decode = ConversationsListItemContext_conversation_graphql.Utils.developmentProjectUnitType_decode;

let ConversationFragment_developmentProjectUnitType_fromString = ConversationsListItemContext_conversation_graphql.Utils.developmentProjectUnitType_fromString;

let ConversationFragment_messageBroadcasStatus_decode = ConversationsListItemContext_conversation_graphql.Utils.messageBroadcasStatus_decode;

let ConversationFragment_messageBroadcasStatus_fromString = ConversationsListItemContext_conversation_graphql.Utils.messageBroadcasStatus_fromString;

let ConversationFragment = {
  conversationContextTypeV5_decode: ConversationFragment_conversationContextTypeV5_decode,
  conversationContextTypeV5_fromString: ConversationFragment_conversationContextTypeV5_fromString,
  developmentProjectUnitType_decode: ConversationFragment_developmentProjectUnitType_decode,
  developmentProjectUnitType_fromString: ConversationFragment_developmentProjectUnitType_fromString,
  messageBroadcasStatus_decode: ConversationFragment_messageBroadcasStatus_decode,
  messageBroadcasStatus_fromString: ConversationFragment_messageBroadcasStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ConversationsListItemContext(props) {
  let conversation = RescriptRelay_Fragment.useFragment(ConversationsListItemContext_conversation_graphql.node, convertFragment$1, props.conversation);
  let match = conversation.conversationContext;
  let tmp;
  if (match !== undefined) {
    switch (match.__typename) {
      case "AvailableConversationContext" :
        let conversationContext = match.context;
        if (conversationContext !== undefined) {
          let tmp$1;
          let exit = 0;
          switch (conversationContext.__typename) {
            case "DevelopmentProject" :
            case "DevelopmentProjectSampleUnit" :
              exit = 3;
              break;
            case "MessageBroadcast" :
              tmp$1 = JsxRuntime.jsx(IconV5.make, {
                icon: "chat",
                size: 32,
                className: "inline align-baseline text-tan-astral"
              });
              break;
            case "BuyerNeedV5" :
            case "RentalNeedV5" :
              exit = 2;
              break;
            case "ForSalePropertyV5" :
            case "RentalPropertyV5" :
              exit = 1;
              break;
            case "__unselected" :
              tmp$1 = null;
              break;
          }
          switch (exit) {
            case 1 :
              let url;
              switch (conversationContext.__typename) {
                case "ForSalePropertyV5" :
                  let match$1 = conversationContext.images;
                  if (match$1 !== undefined) {
                    let match$2 = match$1.edges;
                    if (match$2.length !== 1) {
                      url = undefined;
                    } else {
                      let match$3 = match$2[0];
                      url = match$3 !== undefined ? match$3.node.url : undefined;
                    }
                  } else {
                    url = undefined;
                  }
                  break;
                case "RentalPropertyV5" :
                  let match$4 = conversationContext.images;
                  if (match$4 !== undefined) {
                    let match$5 = match$4.edges;
                    if (match$5.length !== 1) {
                      url = undefined;
                    } else {
                      let match$6 = match$5[0];
                      url = match$6 !== undefined ? match$6.node.url : undefined;
                    }
                  } else {
                    url = undefined;
                  }
                  break;
                default:
                  url = undefined;
              }
              tmp$1 = url !== undefined ? JsxRuntime.jsx("img", {
                  className: "shrink-0 w-9 h-9",
                  src: url
                }) : JsxRuntime.jsx(IconV5.make, {
                  icon: "home",
                  size: 32,
                  className: "inline align-baseline text-tan-astral"
                });
              break;
            case 2 :
              tmp$1 = JsxRuntime.jsx(IconV5.make, {
                icon: "people",
                size: 32,
                className: "inline align-baseline text-tan-astral"
              });
              break;
            case 3 :
              tmp$1 = JsxRuntime.jsx(IconV5.make, {
                icon: "home",
                size: 32,
                className: "inline align-baseline text-tan-astral"
              });
              break;
          }
          let tmp$2;
          let exit$1 = 0;
          switch (conversationContext.__typename) {
            case "DevelopmentProject" :
              tmp$2 = JsxRuntime.jsx(ConversationsListItemContext$Details, {
                top: Stdlib_Option.getOr(conversationContext.name, "Untitled development"),
                bottom: "Development Project"
              });
              break;
            case "DevelopmentProjectSampleUnit" :
              let unitTitle = DevelopmentSampleUnitSummary.title(conversationContext.unitType, conversationContext.name);
              let developmentName = WizardFormUtils.noneIfEmpty(conversationContext.development.name);
              let bottom = developmentName !== undefined ? developmentName + ` • Sample Unit` : "Sample Unit";
              tmp$2 = JsxRuntime.jsx(ConversationsListItemContext$Details, {
                top: unitTitle,
                bottom: bottom
              });
              break;
            case "MessageBroadcast" :
              tmp$2 = JsxRuntime.jsx(ConversationsListItemContext$Details, {
                top: conversationContext.category.name,
                bottom: conversationContext.subject
              });
              break;
            case "BuyerNeedV5" :
            case "RentalNeedV5" :
              exit$1 = 1;
              break;
            case "ForSalePropertyV5" :
            case "RentalPropertyV5" :
              exit$1 = 2;
              break;
            case "__unselected" :
              tmp$2 = null;
              break;
          }
          switch (exit$1) {
            case 1 :
              let match$7 = conversationContext.priceRange;
              let isRental;
              isRental = conversationContext.__typename === "RentalNeedV5";
              tmp$2 = JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: Stdlib_Option.getOr(conversationContext.headline, ""),
                    className: "line-clamp-1"
                  }),
                  JsxRuntime.jsx("div", {
                    children: match$7.minPrice.formatted + ` - ` + match$7.maxPrice.formatted + (
                      isRental ? "/month" : ""
                    ),
                    className: "text-tan-gold"
                  })
                ]
              });
              break;
            case 2 :
              let isRental$1;
              isRental$1 = conversationContext.__typename === "RentalPropertyV5";
              tmp$2 = JsxRuntime.jsx(ConversationsListItemContext$LocationDisplay, {
                location: conversationContext.propertyLocation.fragmentRefs,
                isRental: isRental$1
              });
              break;
          }
          tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx("div", {
                children: tmp$1
              }),
              tmp$2
            ]
          });
        } else {
          tmp = null;
        }
        break;
      case "RemovedConversationContext" :
        let tmp$3 = match.entityType;
        if (tmp$3 === "BROADCAST_MESSAGE" || tmp$3 === "RENTAL_PROPERTY" || tmp$3 === "BUYER_NEED" || tmp$3 === "RENTAL_NEED" || tmp$3 === "DEVELOPMENT_PROJECT" || tmp$3 === "FOR_SALE_PROPERTY" || tmp$3 === "DEVELOPMENT_SAMPLE_UNIT") {
          switch (tmp$3) {
            case "BROADCAST_MESSAGE" :
              tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(IconV5.make, {
                      icon: "chat",
                      size: 32,
                      className: "inline align-baseline text-zinc-400"
                    })
                  }),
                  JsxRuntime.jsx("div", {
                    children: "Broadcast message has been removed",
                    className: "text-gray-600"
                  })
                ]
              });
              break;
            case "BUYER_NEED" :
              tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(IconV5.make, {
                      icon: "people",
                      size: 32,
                      className: "inline align-baseline text-zinc-400"
                    })
                  }),
                  JsxRuntime.jsx("div", {
                    children: "Buyer need has been removed",
                    className: "text-gray-600"
                  })
                ]
              });
              break;
            case "DEVELOPMENT_PROJECT" :
              tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(IconV5.make, {
                      icon: "home",
                      size: 32,
                      className: "inline align-baseline text-zinc-400"
                    })
                  }),
                  JsxRuntime.jsx("div", {
                    children: "Development has been removed",
                    className: "text-gray-600"
                  })
                ]
              });
              break;
            case "DEVELOPMENT_SAMPLE_UNIT" :
              tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(IconV5.make, {
                      icon: "home",
                      size: 32,
                      className: "inline align-baseline text-zinc-400"
                    })
                  }),
                  JsxRuntime.jsx("div", {
                    children: "Sample unit has been removed",
                    className: "text-gray-600"
                  })
                ]
              });
              break;
            case "FOR_SALE_PROPERTY" :
              tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(IconV5.make, {
                      icon: "home",
                      size: 32,
                      className: "inline align-baseline text-zinc-400"
                    })
                  }),
                  JsxRuntime.jsx("div", {
                    children: "Property has been removed",
                    className: "text-gray-600 text-sm"
                  })
                ]
              });
              break;
            case "RENTAL_NEED" :
              tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(IconV5.make, {
                      icon: "people",
                      size: 32,
                      className: "inline align-baseline text-zinc-400"
                    })
                  }),
                  JsxRuntime.jsx("div", {
                    children: "Rental need has been removed",
                    className: "text-gray-600"
                  })
                ]
              });
              break;
            case "RENTAL_PROPERTY" :
              tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(IconV5.make, {
                      icon: "home",
                      size: 32,
                      className: "inline align-baseline text-zinc-400"
                    })
                  }),
                  JsxRuntime.jsx("div", {
                    children: "Rental property has been removed",
                    className: "text-gray-600"
                  })
                ]
              });
              break;
          }
        } else {
          tmp = null;
        }
        break;
      case "__unselected" :
        tmp = null;
        break;
    }
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: "flex flex-row space-x-2 items-center"
  });
}

let make = ConversationsListItemContext;

exports.Details = Details;
exports.LocationDisplay = LocationDisplay;
exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* IconV5 Not a pure module */
